import { render } from "./openEndedResponse.vue?vue&type=template&id=08c059b6"
import script from "./openEndedResponse.vue?vue&type=script&lang=js"
export * from "./openEndedResponse.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__